import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import BasePagination, { PaginationProps } from '../../Pagination';

const Pagination: React.FC<PaginationProps> = withStyles((theme) => ({
  root: {
    marginTop: 'auto',
    paddingTop: theme.spacing(5),
  },
}))(({ classes, ...props }) => (
  <div className={classes.root}>
    <BasePagination {...props} />
  </div>
));

export default Pagination;
